import { colors } from '../../Colors/colors'

export const views = {
   light: {
      whiteBackground: 'bg-base-white',
      actionItemHoverBackground: 'bg-gray-50',
      actionPopoverBorder: 'border-gray-200',
      actionItemText: 'text-gray-700',
      deleteButtonText: 'text-error-600',
      actionHoverBg: 'hover:bg-gray-50',
      outlinePlusIconColor: colors['gray-500'],
      addViewPlusIconColor: colors['primary-600'],
      viewsPopOverHoverColor: 'hover:bg-gray-50',
      viewsPopOverTriggerDefaultColor: 'text-gray-700',
      popoverOpenStyles: 'bg-gray-50 text-gray-700',
      popoverCloseStyles: 'text-gray-600',
      viewsMenuContainerStyles: 'bg-base-white border-gray-200',
      addViewContainer: 'border-gray-300',
      addViewAndTranslationContainer: 'hover:bg-gray-50',
      translationColor: 'text-primary-600',
      viewsOption: 'text-gray-900',
      viewOptionUnselectedIcon: colors['gray-400'],
      viewOptionSelectedIcon: colors['gray-300'],
      menuTriggerSelectedColor: 'bg-gray-200',
      menuTriggerHoverColor: 'hover:bg-gray-200',
      tabPanelsBgColor: 'bg-gray-100',
      viewHeadingColor: 'text-gray-900',
      paneItemTextColor: 'text-gray-900',
      paneItemErrorTextColor: 'text-error-600',
      navigationPaneTextColor: 'text-gray-900',
      navigationPaneDisabledTextColor: 'text-gray-300',
      layOutPaneTextColor: 'text-gray-900',
      sortSidePane: {
         header: {
            backIconColor: colors['gray-500'],
            sortTextColor: 'text-gray-900'
         },
         plusIconColor: colors['gray-500'],
         closeIconColor: colors['gray-400'],
         sortColor: 'text-primary-600',
         sortIconColor: colors['primary-600'],
         sortTickIconColor: colors['primary-600'],
         asyncTextInputColor: 'text-gray-900',
         sortTextOptionColor: 'text-gray-700',
         sortOptionBgColor: 'hover:bg-gray-50',
         sortTypeTextInputColor: 'text-gray-900',
         sortTypeDisableColor: 'text-gray-400',
         asyncCustomOptionStyles: {
            bgColor: 'hover:bg-gray-50',
            color: 'text-gray-700'
         }
      },
      properties: {
         propertyTextColor: 'text-gray-900',
         headerBottomBorderColor: 'border-gray-300',
         closeIconColor: colors['gray-500'],
         chevronLeftIconColor: colors['gray-500'],
         searchIconColor: colors['gray-500'],
         showTextColor: 'text-gray-900',
         descriptionTextColor: 'text-gray-600',
         propertyItemTextColor: 'text-gray-900',
         dotsMoveIcon: colors['gray-500'],
         hideTextColor: 'text-gray-900',
         noDataTextColor: 'text-gray-700',
         refreshIconColor: colors['gray-700'],
         retryIconColor: colors['gray-700'],
         propertyPaneControllerBgColor: 'bg-base-white',
         shownFieldBorderColor: 'border-gray-300',
         propertyIconColor: colors['gray-600'],
         fieldHoverColor: 'bg-gray-50',
         hiddenFieldsSkeletonBgColor: colors['gray-200'],
         // FIXME: need to add this hex color in colors
         hiddenFieldsSkeletonColor: '#F6F7F9',
         loaderColor: colors['gray-400'],
         noDataTitleColor: 'text-gray-900',
         noDataDescriptionColor: 'text-gray-600',
         errorTitleTextColor: 'text-gray-900',
         errorDescriptionTextColor: 'text-gray-600',
         errorRefreshIconColor: colors['base-white'],
         propertiesPaneLeftBorder: 'border-gay-300',
         paneTextColor: 'text-gray-900',
         searchNoDataTitleColor: 'gray-600',
         disabledIconColor: colors['gray-300'],
         eyeIconColor: colors['gray-500'],
         eyeOffColor: colors['gray-300']
      },
      filters: {
         bgColor: 'bg-base-white',
         searchIconColor: colors['gray-500'],
         quickFilterConditionListBorderColor: 'border-gray-300'
      },
      reorderGraphs: {
         paneTextColor: 'text-gray-900'
      },
      table: {
         cellTextColor: 'text-gray-600',
         phoneNumberTextColor: 'text-gray-600',
         agentNameTextColor: 'text-gray-600',
         leadNameTextColor: 'text-gray-600',
         urlTextColor: 'text-primary-600',
         scoreTextColor: 'text-gray-800',
         totalScoreTextColor: 'text-gray-700',
         multiSelectFieldBorderColor: 'border-gray-300',
         whatsAppIconColors: 'border-gray-300 bg-white',
         callIconColors: 'border-gray-300 bg-white',
         leadRemarks: {
            remarksTextColor: 'text-gray-600',
            closeIconColor: colors['gray-500'],
            alignSelfIconColor: colors['gray-700'],
            remarksDescriptionColor: 'text-gray-800',
            remarksHeaderBorderColor: 'border-gray-300',
            remarkTableTextColor: 'text-gray-600',
            iconColor: colors['gray-500'],
            attachmentIconColor: colors['gray-600'],
            retryIconColor: colors['gray-700'],
            dividerColor: 'border-gray-300'
         },
         cellDetailsModal: {
            headerTextColor: 'text-gray-600',
            contentTextColor: 'text-gray-800',
            headerBorderColor: 'border-gray-300',
            closeIconColor: colors['gray-500']
         },
         contactBulkActions: {
            popoverBorderColor: 'border-gray-300',
            popoverBgColor: 'bg-base-white',
            rockerIconColor: colors['gray-700'],
            xCloseIconColor: colors['gray-400'],
            hrLineColor: 'bg-gray-300'
         },
         tooltip: {
            tooltipTextColor: 'text-bg-white',
            tooltipBGColor: 'bg-gray-900'
         },
         cellButton: {
            borderColor: 'border-gray-300',
            hoverBgColor: 'bg-gray-50',
            markerIconColor: colors['gray-500']
         }
      },
      nonAccessibleFilterFields: {
         noLaterButtonBorderColor: 'border-gray-300',
         closeIconColor: colors['gray-300']
      }
   },
   dark: {}
}
